import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className="h-px w-10 bg-black" />
    <span className="text-black text-xs md:text-sm font-bold uppercase tracking-[0.25em]">{children}</span>
  </div>
);
